import type { IntakeStatus } from '../services/api/types.gen';

/**
 * Intake status constants for use throughout the application.
 * These map to the IntakeStatus type from the API.
 */
export const INTAKE_STATUS = {
  RECEIVED: 'received' as IntakeStatus,
  PENDING_REVIEW: 'pending_review' as IntakeStatus,
  UNDER_REVIEW: 'under_review' as IntakeStatus,
  PENDING_CLARIFICATION: 'pending_clarification' as IntakeStatus,
  PENDING_ELIGIBILITY: 'pending_eligibility' as IntakeStatus,
  PENDING_PRIOR_AUTH: 'pending_prior_auth' as IntakeStatus,
  READY_TO_CALL: 'ready_to_call' as IntakeStatus,
  ACCEPTED: 'accepted' as IntakeStatus,
  SCHEDULED: 'scheduled' as IntakeStatus,
  PUSHED_TO_KINNSER: 'pushed_to_kinnser' as IntakeStatus,
  PUSHED_TO_ROGER: 'pushed_to_roger' as IntakeStatus,
  PUSH_FAILED: 'push_failed' as IntakeStatus,
  REJECTED: 'rejected' as IntakeStatus,
  DUPLICATE: 'duplicate' as IntakeStatus,
  EXPIRED: 'expired' as IntakeStatus,
} as const;
